export const baseURL = process.env.REACT_APP_URL

const SummaryAPI = {
    // register : {
    //     url : '/api/user/register',
    //     method : 'post'
    // },
    login : {
        url : '/api/user/login',
        method : 'post'
    },
    forgot_password : {
        url : "/api/user/forgot-password",
        method : 'put'
    },
    forgot_password_otp_verification : {
        url : 'api/user/verify-forgot-password-otp',
        method : 'put'
    },
    resetPassword : {
        url : "/api/user/reset-password",
        method : 'put'
    },
    refreshToken : {
        url : 'api/user/refresh-token',
        method : 'post'
    },
    userDetails : {
        url : '/api/user/user-details',
        method : "get"
    },
    logout : {
        url : "/api/user/logout",
        method : 'get'
    },
    uploadAvatar : {
        url : "/api/user/upload-avatar",
        method : 'put'
    },
    updateUserDetails : {
        url : '/api/user/update-user',
        method : 'put'
    },
    uploadImage : {
        url : '/api/file/upload',
        method : 'post'
    },
    createAddress : {
        url : '/api/address/create',
        method : 'post'
    },
    getAddress : {
        url : '/api/address/get',
        method : 'get'
    },
    updateAddress : {
        url : '/api/address/update',
        method : 'put'
    },
    disableAddress : {
        url : '/api/address/disable',
        method : 'delete'
    },
    makeReview : {
        url : '/api/user/make-review',
        method : 'post'
    },
    getReviews : {
        url : '/api/user/get-reviews',
        method : 'get'
    },
    getUserReviews : {
        url : '/api/user/get-user-reviews',
        method : 'get'
    },
    getRecommendations: {
        url: '/api/user/get-recommendations',
        method: 'post'
    },
    sendFollowRequest: (userId) => ({
        url: `/api/user/${userId}/follow`,
        method: 'post',
    }),
    watchlist: (userId) => ({
        url: `/api/user/${userId}/add`,
        method: 'post',
    }),
    fetchWatchlist: (userId) => ({
        url: `/api/user/${userId}/watchlist`,
        method: 'get',
    }),
}

export default SummaryAPI;